import { InjectionToken } from '@angular/core';

export const SOFTLINE_PAGE_SETTINGS_HOST_NAME = new InjectionToken<string>('SOFTLINE_PAGE_SETTINGS_HOST_NAME');
export const SOFTLINE_NAME_PAGE_SETTINGS_OBJECT_STORE = 'page-settings';
